import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AspMyItemListService {

  constructor(
    private http: HttpClient
  ) { }

  getItemList(names, variantKey, garageKey): Observable<any>{
    const headers = new HttpHeaders({
      'x-api-key': `${GlobalVariable.AUTOVERSE_PARTS_KEY}`,
    });

    // console.log('-----Get Item List-----------');    
    return this.http.get(`${GlobalVariable.BASE_API_URL_AUTOVERSE_PARTS}` + '/spare/product/search/?names='+names+'&variantKey='+variantKey+'&garageKey='+garageKey, { headers: headers });
  }
  getSuggest(relevancyCount, variant,partNames, garageKey): Observable<any>{
    const headers = new HttpHeaders({
      'x-api-key': `${GlobalVariable.AUTOVERSE_ELASTIC_KEY}`,
    });

    
    return this.http.get(`${GlobalVariable.BASE_API_URL_ELASTIC}` + '/part-name-suggestions-warehouse?relevancyCount='+relevancyCount+'&variant='+variant+'&partNames='+partNames+'&garageKey='+garageKey, { headers: headers });
  }
  private wishlistUpdated = new BehaviorSubject<void>(undefined);

  wishlistUpdated$ = this.wishlistUpdated.asObservable();

  notifyWishlistChanged() {
    this.wishlistUpdated.next(); 
  }
  kitItemNames(){
    // console.log('------ get Kit Names--------')
     return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}` + '/spare/kit/getAll/kitItemNames');

  }
}
